
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const PhoneDevice = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M5.5,1.9V23.1H16.1a3.4,3.4,0,0,0,3.4-3.4V1.9ZM18,3.4V5.6H7V3.4Zm0,3.7v8.8H7V7.1ZM16.1,21.6H7V17.4H18v2.3A1.8,1.8,0,0,1,16.1,21.6Z"></path>
            <circle cx="12.5" cy="19.5" r="1.1"></circle>
          </g>
        </g>
      </g>
    </IconBase>);
};

PhoneDevice.defaultProps = {
  title: 'Phone Device',
};

export default PhoneDevice;
